module.exports = __webpack_public_path__ + "static/media/bolso (7).e0af4417.jpg";